import React, { useMemo } from 'react';
import LibTaskCompletionsModal from '@lib/components/TaskCompletions/TaskCompletionsModal/TaskCompletionsModal';
import {
  TaskCompletionsModalActions,
  TaskCompletionsModalUrls,
} from '@lib/components/TaskCompletions/TaskCompletionsModal/types';
import { APP_URLS } from 'constants/urls';
import useTaskCompletionWriteActions from 'hooks/useTaskCompletionWriteActions';

export const taskCompletionsModalUrls: TaskCompletionsModalUrls = {
  getTaskUrl: (id) =>
    APP_URLS.dashboard.tasks.reporting.getDynamicPath({ pathParts: { id } }),
  getInterventionUrl: (id) =>
    APP_URLS.dashboard.interventions.view.getDynamicPath({
      pathParts: { id },
    }),
  getDocumentationUrl: (id) =>
    APP_URLS.dashboard.documentation.view.getDynamicPath({
      pathParts: { id },
    }),
};

type Props = Omit<
  React.ComponentProps<typeof LibTaskCompletionsModal>,
  'urls' | 'actions'
>;

export default function TaskCompletionsModal(props: Props) {
  const { task } = props;
  const { onStatusChange, isStatusUpdating, onCreateInterventionForSelected } =
    useTaskCompletionWriteActions({ task });

  const actions = useMemo<TaskCompletionsModalActions>(
    () => ({
      onStatusChange,
      isStatusUpdating,
      onCreateInterventionForSelected,
    }),
    [onStatusChange, isStatusUpdating, onCreateInterventionForSelected],
  );

  return (
    <LibTaskCompletionsModal
      {...props}
      urls={taskCompletionsModalUrls}
      actions={actions}
    />
  );
}
